import { render, staticRenderFns } from "./contact-form.vue?vue&type=template&id=bdd00094&scoped=true&"
import script from "./contact-form.ts?vue&type=script&lang=ts&"
export * from "./contact-form.ts?vue&type=script&lang=ts&"
import style0 from "./contact-form.scss?vue&type=style&index=0&id=bdd00094&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd00094",
  null
  
)

export default component.exports